import './PanelRead.css'
import classNames from 'classnames'

const PanelRead = ({ children, className }) => {

    const compClass = classNames('panel-read', className)

    return (
        <div className={compClass} >
            {children}
        </div>
    )
}
export default PanelRead
